<!-- 旗舰话费 -->
<template>
  <div>

    <div class="wrap">
      <!-- 导航栏 -->
      <div class="nav">
        <div class="back">‹</div>
        <div class="title">话费充值收银台</div>
        <div class="safe"><span class="s-ico">✓</span>安全保障</div>
      </div>

      <!-- 顶部警示绿卡 -->
      <div class="top-card">
        <div class="wm">¥</div>
        <div class="top-head">
          <div class="wx-logo">
            <div class="mark">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M9 3.2C4.9 3.2 1.7 5.9 1.7 9.3c0 1.9 1 3.6 2.7 4.8L3.7 16l2.3-1.2c.9.3 1.9.4 3 .4h.5a5 5 0 0 1-.2-1.4c0-3.2 3.1-5.7 6.9-5.7h.6C16.2 5.3 12.9 3.2 9 3.2Z" fill="#fff" />
                <path d="M22.3 13.8c0-2.7-2.7-4.9-6-4.9s-6 2.2-6 4.9 2.7 4.9 6 4.9c.7 0 1.4-.1 2-.3l1.9 1-.5-1.6c1.6-.9 2.6-2.3 2.6-4Z" fill="#fff" />
              </svg>
            </div>
            <div class="n1">微信支付</div>
            <div class="n2">WeChat Pay</div>
          </div>
          <p>重复支付、修改金额或号码、修改支付渠道不退不补</p>
        </div>
        <div class="top-row">
          <div class="time-box">
            <div class="lbl">剩余时间</div>
            <div class="val" id="timer">{{payTimeInfo.timePayoutMin}}:{{payTimeInfo.timePayoutSec}}</div>
          </div>
          <div class="warn-box">
            <div class="b">只能充值话费</div>
            <div class="s">切勿转账</div>
          </div>
        </div>
      </div>

      <!-- 主体卡 -->
      <div class="main-card">
        <div class="mc-head">
          <div class="ico">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="6" y="2" width="12" height="20" rx="2.5" stroke="#fff" stroke-width="2" />
              <line x1="10" y1="18.5" x2="14" y2="18.5" stroke="#fff" stroke-width="2" stroke-linecap="round" />
            </svg>
          </div>
          <div class="t">充值时必须充值到下方手机号</div>
        </div>
        <div class="pay-sub">按订单金额支付，订单金额多少就付多少</div>
        <div class="amount" id="amount" v-if="orderInfo.orderId==null">
          <small>¥</small>--
        </div>
        <div class="amount" id="amount" v-else>
          <small>¥</small>{{orderInfo.amount.toFixed(2)}}
        </div>
        <div class="name-box">
          <div class="t">机主姓名<small>点击姓名中的单个文字复制</small></div>
          <div class="chars" v-if="orderInfo.orderId!=null">
            <div class="char" data-copy="*" v-for="(item, index) in orderInfo.phoneOwners" :key="index" @click="copyPhoneOwnerOne(item)">{{item}}</div>
          </div>
        </div>
        <div class="phone-num pending" id="phone" v-if="orderInfo.orderId==null">匹配后显示</div>
        <div class="phone-num" id="phone" v-else>{{orderInfo.phone}}</div>
        <button class="copy-btn" id="copyBtn" @click="copyPhoneNo(orderInfo.phone)">点击复制充值手机号</button>
      </div>

      <!-- 操作步骤 -->
      <div class="steps-card">
        <h3>微信话费充值操作</h3>
        <div class="lead">如果您第一次使用本充值入口，按下面 5 步操作即可</div>
        <div class="steps">
          <div class="step">
            <div class="no">1</div>
            <div class="txt">打开微信，依次进入“我”→“服务”</div>
          </div>
          <div class="step">
            <div class="no">2</div>
            <div class="txt">在生活服务中点击“手机充值”</div>
          </div>
          <div class="step">
            <div class="no">3</div>
            <div class="txt">长按号码输入框，清空原号码</div>
          </div>
          <div class="step">
            <div class="no">4</div>
            <div class="txt">粘贴本页复制的充值手机号</div>
          </div>
          <div class="step">
            <div class="no">5</div>
            <div class="txt">选择与订单完全相同的金额并支付</div>
          </div>
        </div>
      </div>

      <!-- 规则 -->
      <div class="rules-card">
        <ul class="rules">
          <li>必须充值<b>与订单金额相同</b>，否则卡单不到账。</li>
          <li>更改<b>支付方式、修改金额、重复支付</b>造成卡单不退不补。</li>
          <li>付款后超过15分钟未到账再联系客服查单。</li>
        </ul>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer">
      <div class="inner">
        <div class="assure"><span class="s-ico">✓</span><span>安全保障<br>资金无忧</span></div>
        <button class="btn-pay" id="mainBtn" disabled v-if="orderInfo.orderId==null">
          {{payTimeInfo.timeDownNo}} 秒
        </button>
        <button class="btn-pay" id="mainBtn" v-else @click="gotoWx(orderInfo.phone)">
          去微信充值 ›
        </button>
      </div>
    </div>

    <!-- 匹配中弹窗 -->
    <div class="mask" id="maskMatch" v-if="orderInfo.orderId==null">
      <div class="modal" v-if="payTimeInfo.timeDownNo>0">
        <div class="ring">
          <div class="core">✓</div>
        </div>
        <h2>匹配中，请耐心等待</h2>
        <p>正在获取订单信息，通常只需十几秒钟</p>
        <div class="count-pill"><span id="sec">{{payTimeInfo.timeDownNo}}</span><small>秒</small></div>
        <div class="dots"><i class="on"></i><i class="on"></i><i class="on"></i></div>
      </div>
      <div class="modal" v-else>
        <div class="ring">
          <div class="core">×</div>
        </div>
        <h2>失败</h2>
        <p>订单获取失败，请关闭页面或重新下单</p>
        <div class="count-pill"><span id="sec">OK</span><small></small></div>
        <div class="dots"><i class="on"></i><i class="on"></i><i class="on"></i></div>
      </div>
    </div>

    <!-- 核对姓名弹窗 -->
    <div class="mask" id="maskName" v-if="payTimeInfo.timeLastSss>0&&orderInfo.orderId!=null&&dialogPhoneOwner">
      <div class="modal">
        <div class="wx-badge">微</div>
        <h2>请核对机主姓名</h2>
        <p>微信充值页面如要求填写姓名，请逐字点击下方姓名复制。</p>
        <div class="chars">
          <div class="char" data-copy="*" v-for="(item, index) in orderInfo.phoneOwners" :key="index" @click="copyPhoneOwnerOne(item)">{{item}}</div>
        </div>
        <button @click="dialogPhoneOwner=false">我记住了</button>
      </div>
    </div>

    <!-- 手机号已复制弹窗（去微信充值） -->
    <div class="mask" id="maskCopy" v-if="dialogToWx">
      <div class="modal">
        <div class="wx-badge">微</div>
        <h2>手机号已复制</h2>
        <p>请打开微信的“我 → 服务 → 手机充值”，粘贴手机号</p>
        <div class="redphone">{{orderInfo.phone}}</div>
        <p>并选择 {{orderInfo.amount.toFixed(2)}} 元充值，切勿转账。</p>
        <a class="btn-pay" style="display:flex;justify-content: center;" href="weixin://" @click="dialogToWx=false" v-if="orderInfo.paykind==1">
          我知道了 + 打开微信
        </a>
        <button @click="dialogToWx=false" v-else>
          我知道了
        </button>
      </div>
    </div>

    <!-- 支付超时 -->
    <div class="mask" v-if="payTimeInfo.timeLastSss<=0&&orderInfo.statePayd!=true&&orderInfo.csTimeoutClose==true">
      <div class="modal">
        <div class="ring">
          <div class="core">×</div>
        </div>
        <h2>订单已超时</h2>
        <p style="padding-bottom:20px;">您的订单支付超时，请关闭页面或重新下单</p>
      </div>
    </div>

    <!-- 支付成功 -->
    <div class="mask" v-if="orderInfo.statePayd==true">
      <div class="modal">
        <div class="ring">
          <div class="core">✓</div>
        </div>
        <h2>订单成功</h2>
        <p style="padding-bottom:20px;">系统已收到您的金额</p>
      </div>
    </div>

    <div class="toast" id="toast">已复制</div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    alipInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogPhoneOwner: true,
      dialogToWx: false,
    };
  },
  computed: {},
  created() {
    //设置标题
    document.title = "收银台";
    //加载样式
    this.loadTheme();
  },
  methods: {
    // 动态导入本地 CSS 文件
    async loadTheme() {
      try {
        await import("./product_phone_balance_wx.css");
      } catch (error) {
        //console.error("CSS err", error);
      }
    },
    // 点击复制-单个姓名
    copyPhoneOwnerOne(name) {
      if (name && name == "*") {
        return;
      }
      //复制1
      this.$parent.copySome(
        name,
        1,
        () => {},
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = '已复制"' + name + '"';
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
    },
    // 点击复制-手机号
    copyPhoneNo(num) {
      //复制2
      this.$parent.copySome(
        num,
        2,
        () => {
          this.copyPhoneIf = true;
          if (ifShow) {
            this.showCopy = true;
            setTimeout(() => {
              this.showCopy = false;
            }, 1000);
          }
        },
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = "手机号已复制";
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
    },
    // 去微信
    gotoWx(num) {
      //复制2
      this.$parent.copySome(
        num,
        2,
        () => {
          this.copyPhoneIf = true;
          if (ifShow) {
            this.showCopy = true;
            setTimeout(() => {
              this.showCopy = false;
            }, 1000);
          }
        },
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = "手机号已复制";
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
      // 打开弹窗
      this.dialogToWx = true;
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
